import Vue from 'vue'
import Vuex from 'vuex'

import * as auth from './modules/auth'
import * as customer from './modules/customer'
import * as feature from './modules/feature'
import * as hardware from './modules/hardware'
import * as admin from './modules/admin'
import * as announcement from './modules/announcement'
import * as notification from './modules/notification'
import * as role from './modules/role'
import * as firmware from './modules/firmware'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    breadcrumbs: [],
    menusCustomerActive: false,
  },
  mutations: {
    setBreadcrumbs(state, breadcrumbs) {
      state.breadcrumbs = breadcrumbs
    },
    setMenusCustomerActive(state, menusCustomerActive) {
      state.menusCustomerActive = menusCustomerActive
    },
  },
  actions: {},
  modules: {
    auth,
    customer,
    feature,
    hardware,
    admin,
    announcement,
    notification,
    role,
    firmware,
  },
})
